import { useMutation } from "@tanstack/react-query";
import { useRef } from "react";

import { OrderRepository } from "@/repositories/order";
import { RefundOrderAmount } from "@/types/payment";

export const useRefund = () => {
  const orderRepository = useRef(new OrderRepository());

  return useMutation({
    mutationFn: async ({
      orderId,
      data,
    }: {
      orderId: string;
      data: RefundOrderAmount;
    }) => {
      return await orderRepository.current.refundOrder(
        orderId,
        data.amount,
        data.reason ?? undefined,
      );
    },
  });
};
